import { render, staticRenderFns } from "./Under15ReplyModal.vue?vue&type=template&id=78a04d90&scoped=true"
import script from "./Under15ReplyModal.vue?vue&type=script&lang=js"
export * from "./Under15ReplyModal.vue?vue&type=script&lang=js"
import style0 from "./Under15ReplyModal.vue?vue&type=style&index=0&id=78a04d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a04d90",
  null
  
)

export default component.exports